import React from 'react';
import MainContent from '../components/MainContent/MainContent';

const AccueilPage: React.FC = () => {
  return (
    <>
      <div className="container">
        <h2 className="section-title">🌿 Un cadre exceptionnel</h2>
        <p>Situé a Sablonnière dans la vallée du petit morin en Seine et Marne, notre domaine offre un environnement naturel et varié.</p>


        <h2 className="section-title">🌿 L'Intimité d'un Petit Comité</h2>
        <p>Vivez une expérience privilégiée en groupe restreint (1 à 3 personnes maximum). Loin du tourisme de masse, nous privilégions la qualité des échanges et la sérénité. C’est le format idéal pour une connexion profonde avec la nature et une complicité réelle avec votre monture. Ne possédant pas de poney, nous ne pouvons accueillir que des adolescents et adultes. 
          Plus d'informations sur demande. Pour les plus jeunes ne pouvant pas encore monter à cheval, nous proposons uen balade en calèche grace a un partenariat avec l'attelage de Pégase</p>

        <h3>🐴 Le Bien-être Animal au Cœur de l'Expérience</h3>
        <p>Chez nous, la balade commence par une rencontre. Nous accordons une importance capitale au respect du cheval : rythme adapté, matériel de qualité et chevaux vivant en troupeau toute l'année. Vous apprendrez à les brosser et à les comprendre, créant ainsi un lien de confiance avant même de mettre le pied à l'étrier.</p>

        <h3>🎒 Votre Évasion Clef en Main & Sur-Mesure</h3>
        <p>Oubliez le stress de l'organisation. Que vous rêviez d'une exploration a la rencontre de l'histoire et des producteurs ou d'une promenade contemplative, nous traçons l'itinéraire selon vos envies. Du point de départ au retour, notre équipe s'occupe de tout pour garantir votre confort et votre sécurité.</p>

        <h3>🗺️ Une Aventure Accessible à Tous</h3>
        <p>Nul besoin d'être un cavalier émérite pour découvrir les trésors cachés de nos sentiers. Dans notre ambiance familiale et bienveillante, nous adaptons nos parcours à votre niveau. Que vous soyez inéxpérimenté ou passionné, le plaisir reste la seule priorité.</p>
      </div>
    </>
  );
};

export default AccueilPage;